import { inject, injectable } from "inversify";
import { IDownload, type IDownloadOnBrowser } from "../types";
import { DITypes } from "@/core/@types/types";

@injectable()
export default abstract class Download implements IDownload {
  @inject(DITypes.DOWNLOAD_ON_BROWSER)
  private downloadFileOnBrowser!: IDownloadOnBrowser;

  abstract getMimeType(): string;

  private getTypedBlob(blob: Blob): Blob {
    return new Blob([blob], { type: this.getMimeType() });
  }

  execute(file: Blob, fileName: string) {
    this.downloadFileOnBrowser.download(this.getTypedBlob(file), fileName);
  }
}
